// frontend/packages/business-console/src/pages/Quotes/demoData.js
//
// Handcrafted fixtures for the Quotes list page. Activated via the
// `?demo=1` query string (sticky via `localStorage["pulse.demo"]`,
// shared mechanism with the Pulse dashboard). Used for marketing
// screenshots without touching real tenant data.
//
// Numbers tuned to match the SMB field-service Pulse fixtures so the
// demo across pages reads as a coherent business.

export const demoQuotesList = {
  items: [
    {
      _id: 'demo_quote_94',
      number: 'Q-0094',
      state: 'sent',
      customerId: 'demo_customer_tilbury',
      customerName: 'Tilbury Construction',
      title: 'Tear-off + new shingle',
      total: 421000,
      currency: 'USD',
      createdAt: '2026-05-26T09:18:00Z',
      updatedAt: '2026-05-26T09:18:00Z',
    },
    {
      _id: 'demo_quote_93',
      number: 'Q-0093',
      state: 'viewed',
      customerId: 'demo_customer_santos',
      customerName: 'Maria Santos',
      title: 'Gutter cleaning + soffit repair',
      total: 67500,
      currency: 'USD',
      createdAt: '2026-05-25T16:42:00Z',
      updatedAt: '2026-05-26T10:02:00Z',
    },
    {
      _id: 'demo_quote_92',
      number: 'Q-0092',
      state: 'draft',
      customerId: 'demo_customer_henderson',
      customerName: 'Henderson Group',
      title: 'Annual maintenance contract',
      total: 540000,
      currency: 'USD',
      createdAt: '2026-05-25T14:11:00Z',
      updatedAt: '2026-05-25T14:11:00Z',
    },
    {
      _id: 'demo_quote_91',
      number: 'Q-0091',
      state: 'accepted',
      customerId: 'demo_customer_acme',
      customerName: 'Acme Roofing LLC',
      title: 'Storm damage repair',
      total: 245000,
      currency: 'USD',
      createdAt: '2026-05-24T11:30:00Z',
      updatedAt: '2026-05-26T13:14:00Z',
    },
    {
      _id: 'demo_quote_90',
      number: 'Q-0090',
      state: 'accepted',
      customerId: 'demo_customer_wagner',
      customerName: 'Wagner Hospitality',
      title: 'New install — 4 units',
      total: 312000,
      currency: 'USD',
      createdAt: '2026-05-23T15:10:00Z',
      updatedAt: '2026-05-25T15:40:00Z',
    },
    {
      _id: 'demo_quote_89',
      number: 'Q-0089',
      state: 'declined',
      customerId: 'demo_customer_obrien',
      customerName: "Madelyn O'Brien",
      title: 'Deck refinish',
      total: 68000,
      currency: 'USD',
      createdAt: '2026-05-22T10:00:00Z',
      updatedAt: '2026-05-24T17:30:00Z',
    },
    {
      _id: 'demo_quote_88',
      number: 'Q-0088',
      state: 'sent',
      customerId: 'demo_customer_whitfield',
      customerName: 'Jordan Whitfield',
      title: 'Back deck estimate',
      total: 195000,
      currency: 'USD',
      createdAt: '2026-05-22T08:55:00Z',
      updatedAt: '2026-05-22T08:55:00Z',
    },
    {
      _id: 'demo_quote_87',
      number: 'Q-0087',
      state: 'expired',
      customerId: 'demo_customer_pinewood',
      customerName: 'Pinewood Estates HOA',
      title: 'Common-area landscaping',
      total: 158000,
      currency: 'USD',
      createdAt: '2026-04-26T13:20:00Z',
      updatedAt: '2026-05-26T00:01:00Z',
    },
  ],
  hasMore: false,
  nextCursor: null,
};
